import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import {
  ArrowUpDown,
  Search,
  Euro,
  Layers3,
  Calendar,
  Package,
  Image,
} from "lucide-react";

import React from "react";

const columnHelper = createColumnHelper();

const columns = [
  columnHelper.accessor("imgUrl", {
    // cell: (info) => info.getValue(),
    cell: (info) => (
      <span className="flex items-center justify-center">
        <img src={info.getValue()} alt="" width={35} height={35} className="" />
      </span>
    ),
    header: () => (
      <span className="flex items-center">
        <Image className="mr-2" size={16} />
      </span>
    ),
  }),

  columnHelper.accessor("date", {
    cell: (info) => info.getValue(),
    header: () => (
      <span className="flex items-center">
        <Calendar className="mr-2" size={16} /> Date
      </span>
    ),
  }),

  columnHelper.accessor("name", {
    cell: (info) => info.getValue(),
    header: () => (
      <span className="flex items-center justify-center">
        <Package className="mr-2" size={16} /> Produit
      </span>
    ),
  }),
  columnHelper.accessor("price", {
    id: "price",
    cell: (info) => (
      <span className="italic text-center text-blue-600">
        {parseFloat(info.getValue()).toFixed(2) || info.getValue()} €
      </span>
    ),
    header: () => (
      <span className="flex items-center">
        <Euro className="mr-2" size={16} /> Prix
      </span>
    ),
  }),
  columnHelper.accessor("quantityVariation", {
    header: () => (
      <span className="flex items-center">
        <Layers3 className="mr-2" size={16} /> Qty
      </span>
    ),
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor("ca", {
    header: () => (
      <span className="flex items-center">
        <Euro className="mr-2" size={16} /> CA
      </span>
    ),
    cell: (info) => info.getValue(),
  }),
];

export const Table = ({ iData: data }) => {
  // const [data] = React.useState(() => [...iData]);
  const [sorting, setSorting] = React.useState([]);
  const [globalFilter, setGlobalFilter] = React.useState("");

  const table = useReactTable({
    data,
    // @ts-ignore
    columns,
    state: {
      sorting,
      globalFilter,
    },
    initialState: {
      pagination: {
        pageSize: 5,
      },
    },
    getCoreRowModel: getCoreRowModel(),
    // @ts-ignore
    onSortingChange: setSorting,
    getSortedRowModel: getSortedRowModel(),

    onGlobalFilterChange: setGlobalFilter,
    getFilteredRowModel: getFilteredRowModel(),
  });

  return (
    <div className="flex flex-col mx-auto py-2 sm:px-6 lg:px-2">
      <div className="mb-4 relative">
        <input
          value={globalFilter ?? ""}
          onChange={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
        />
        <Search
          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
          size={20}
        />
      </div>

      <div className="overflow-x-auto bg-white rounded-lg">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="">
            {table.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header) => (
                  <th
                    key={header.id}
                    className="px-6 py-3 text-center text-xs font-medium text-gray-500 tracking-wider"
                  >
                    <div
                      {...{
                        className: header.column.getCanSort()
                          ? "cursor-pointer select-none flex items-center justify-center"
                          : "",
                        onClick: header.column.getToggleSortingHandler(),
                      }}
                    >
                      {flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                      <ArrowUpDown className="ml-2" size={14} />
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {table.getRowModel().rows.map((row) => (
              <tr key={row.id} className="hover:bg-gray-50">
                {row.getVisibleCells().map((cell) => (
                  <td
                    key={cell.id}
                    className="px-2 py-1 whitespace-nowrap text-xs text-gray-500 text-center"
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
